import styled from "styled-components";
import { ImBin2 } from "react-icons/im";
import { FaSquareMinus } from "react-icons/fa6";
import { FaPlusSquare } from "react-icons/fa";

const CartItem = ({
  item,
  theme,
  id,
  quantity,
  onQuantityChange,
  removeFromCart,
  checkout,
}) => {
  const increaseQty = () => onQuantityChange(id, 1);
  const decreaseQty = () => {
    if (quantity > 0) onQuantityChange(id, -1);
  };
  // console.log("item", item);
  return (
    <ItemCartList theme={theme} checkout={checkout}>
      {/* Product */}
      <CartColumn flex="40%" theme={theme}>
        <ProductInfo>
          <ProductImage src={item.image_1920} alt={item.title} />
          <ProductDetails>
            <ProductTitle theme={theme}>{item.title}</ProductTitle>
            <ProductDescription theme={theme}>
              {item.description}
            </ProductDescription>
          </ProductDetails>
        </ProductInfo>
      </CartColumn>

      {/* Price */}
      <CartColumn flex="10%" theme={theme}>
        {item.newPrice < item.price && item.has_discounted_price ? (
          <PriceOuter>
            <DiscountWrapper>
              <OverlinedPrice theme={theme}>
                {item.currency} {item.price}
              </OverlinedPrice>
            </DiscountWrapper>
            <FinalPrice theme={theme}>
              {item.currency} {item.newPrice}
            </FinalPrice>
          </PriceOuter>
        ) : (
          <FinalPrice theme={theme}>
            {item.currency} {item.newPrice}
          </FinalPrice>
        )}
      </CartColumn>

      {/* Quantity */}
      <CartColumn flex="10%" theme={theme}>
        <QuantityWrapper theme={theme}>
          <FaSquareMinus
            className="icon"
            onClick={decreaseQty}
            style={{ color: "#9c9a9a" }}
          />
          <Count theme={theme}>{item.quantity}</Count>
          <FaPlusSquare
            className="icon"
            onClick={increaseQty}
            style={{ color: "#9c9a9a" }}
          />
        </QuantityWrapper>
      </CartColumn>

      {/* Total */}
      <CartColumn flex="10%" theme={theme}>
        <TotalPrice theme={theme}>
          {item.currency} {item.totalPrice}
        </TotalPrice>
      </CartColumn>

      {/* Delete Icon */}
      <CartColumn flex="5%" theme={theme}>
        <DeleteIcon
          theme={theme}
          onClick={() =>
            removeFromCart({
              productId: item.id,
            })
          }
        />
      </CartColumn>
    </ItemCartList>
  );
};

export default CartItem;

const ItemCartList = styled.div`
  display: flex;
  width: 100%;
  min-width: fit-content;
  align-items: center;
  padding: 10px 0;
  border-bottom: ${({ checkout }) =>
    checkout === true ? "" : "2px solid #9c9a9a"};
`;

const CartColumn = styled.div`
  flex: ${({ flex }) => flex};
  padding: 10px;
  text-align: left;
  display: flex;
  align-items: center;
`;

// 1️⃣ Product Column (Image + Title + Description)
const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 470px) {
    flex-direction: column;
  }
`;
const PriceOuter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 470px) {
    flex-direction: column;
  }
`;

const ProductImage = styled.img`
  width: 100px;
  height: 84px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 10px;
  flex-shrink: 0;
  @media (max-width: 768px) {
    width: 70px;
    height: 60px;
  }
`;

const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
`;
const ProductTitle = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 29px;
  color: ${({ theme }) => theme.textColor.primary};
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;
const ProductDescription = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${({ theme }) => theme.textColor.primary};
  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 12px;
  }
`;

// 2️⃣ Price Column (Discount + Price)
const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const DiscountWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
`;
const DiscountText = styled.span`
  color: ${({ theme }) => theme.primaryColor.primary};
  font-size: 14px;
`;

const OverlinedPrice = styled.span`
  text-decoration: line-through;
  color: #9c9a9a;
  font-size: 14px;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const FinalPrice = styled.span`
  color: ${({ theme }) => theme.primaryColor.primary};
  font-weight: bold;
  font-size: 16px;
  margin-left: 0.5rem;
  @media (max-width: 768px) {
    font-size: 12px;
  }
  @media (max-width: 470px) {
    margin-left: 0rem;
  }
`;

// 3️⃣ Quantity Column (Counter)
const QuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  padding: 5px 10px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
`;

const Count = styled.span`
  margin: 0 5px;
  font-weight: bold;
  color: #9c9a9a;
  @media (max-width: 375px) {
    font-size: small;
  }
`;

const Icon = styled.i`
  color: #9c9a9a;
  cursor: pointer;
`;

// 4️⃣ Total Column (Final Price)
const TotalPrice = styled.span`
  color: ${({ theme }) => theme.primaryColor.primary};
  font-weight: bold;
  font-size: 16px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

// 5️⃣ Delete Icon
const DeleteIcon = styled(ImBin2)`
  color: ${({ theme }) => theme.primaryColor.primary};
  cursor: pointer;
`;
